var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "app-container view-container",
      attrs: {
        "label-position": "top",
        model: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
      },
    },
    [
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("cancelText"))),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleConfirm },
                    },
                    [_vm._v(_vm._s(_vm.$t("okText")))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("BusinessPurchaseOrder2.detailTitle")) + " "
          ),
        ]
      ),
      [
        _c(
          "el-row",
          { attrs: { gutter: 10 } },
          [
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseOrder2.Unit"),
                      prop: "shippingMethod",
                    },
                  },
                  [
                    _c("BjSelectLov", {
                      attrs: { "option-list": _vm.SHIPPING_METHODS },
                      on: { change: _vm.changeShippingMethod },
                      model: {
                        value: _vm.form.shippingMethod,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "shippingMethod", $$v)
                        },
                        expression: "form.shippingMethod",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.form.shippingMethod === "Pallet"
              ? _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseOrder2.form.palletQty"
                          ),
                          prop: "palletQty",
                        },
                      },
                      [
                        _c("BjInputNumber", {
                          staticClass: "full-width",
                          attrs: {
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                            max: 140,
                            controls: false,
                          },
                          on: { blur: _vm._getCsgPurchaseOrderUnavailableTime },
                          model: {
                            value: _vm.form.palletQty,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "palletQty", $$v)
                            },
                            expression: "form.palletQty",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.form.shippingMethod === "Carton"
              ? _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseOrder2.form.carton"),
                          prop: "containerQty",
                        },
                      },
                      [
                        _c("BjInputNumber", {
                          staticClass: "full-width",
                          attrs: {
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                            controls: false,
                          },
                          model: {
                            value: _vm.form.containerQty,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "containerQty", $$v)
                            },
                            expression: "form.containerQty",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.form.shippingMethod == "Container"
              ? _c(
                  "div",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseOrder2.form.containerId"
                              ),
                              prop: "containerId",
                            },
                          },
                          [
                            _c("BjInput", {
                              attrs: {
                                placeholder: _vm.$t("inputText"),
                                maxlength: _vm.MAX_LENGTH.DEFAULT,
                              },
                              model: {
                                value: _vm.form.containerId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "containerId", $$v)
                                },
                                expression: "form.containerId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseOrder2.form.containerLength"
                              ),
                              prop: "containerLength",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.CONTAINER_LENGTH_LIST,
                              },
                              model: {
                                value: _vm.form.containerLength,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "containerLength", $$v)
                                },
                                expression: "form.containerLength",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseOrder2.dropOffMethod"
                              ),
                              prop: "dropOffMethod",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.DROPOFF_METHODS_LIST,
                              },
                              on: {
                                change: _vm._getCsgPurchaseOrderUnavailableTime,
                              },
                              model: {
                                value: _vm.form.dropOffMethod,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "dropOffMethod", $$v)
                                },
                                expression: "form.dropOffMethod",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.showTime
              ? _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseOrder2.receiveDate"),
                          prop: "receiveDate",
                        },
                      },
                      [
                        _c("BjDateTimerPicker", {
                          attrs: { "picker-options": _vm.pickerOptions },
                          model: {
                            value: _vm.form.receiveDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "receiveDate", $$v)
                            },
                            expression: "form.receiveDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.form.shippingMethod != "Container"
              ? _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseOrder2.form.thirdCode"
                          ),
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t("inputText"),
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                          },
                          model: {
                            value: _vm.form.thirdCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "thirdCode", $$v)
                            },
                            expression: "form.thirdCode ",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      _c(
        "div",
        { staticClass: "bj-row mt20" },
        [
          _c(
            "BjDivider",
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("BusinessPurchaseComponentsPur.information")) +
                  " "
              ),
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("BusinessPurchaseComponentsPur.addingGoods")
                      )
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onImport } },
                  [_vm._v(_vm._s(_vm.$t("EXCELImportText")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { disabled: _vm.selection.length === 0 },
                    on: {
                      click: function ($event) {
                        return _vm.onDelete()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("delText")))]
                ),
              ],
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "bj-col bj-col-24",
              staticStyle: { "border-left": "none" },
            },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.form.purchaseOrderGoods,
                    border: "",
                    script: "",
                    "max-height": "600px",
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      width: "70",
                      align: "center",
                      fixed: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "standardSkuCode",
                      label: "SKU",
                      align: "center",
                      fixed: "left",
                      width: "170",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "skuName",
                      label: _vm.$t("BusinessPurchaseOrder2.form.skuName"),
                      align: "center",
                      width: "170",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", width: "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("span", { staticClass: "must" }, [_vm._v("*")]),
                            _vm._v(
                              " " + _vm._s(_vm.$t("goodsSku.detail.qty")) + " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("BjInputNumber", {
                              staticClass: "full-width",
                              attrs: { clearable: "", controls: false },
                              model: {
                                value: row.planQty,
                                callback: function ($$v) {
                                  _vm.$set(row, "planQty", $$v)
                                },
                                expression: "row.planQty",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "BusinessPurchaseOrder2.form.batchCode"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("BjInput", {
                              staticClass: "full-width",
                              attrs: {
                                clearable: "",
                                controls: false,
                                disabled: row.needExpired !== 1,
                              },
                              model: {
                                value: row.batchCode,
                                callback: function ($$v) {
                                  _vm.$set(row, "batchCode", $$v)
                                },
                                expression: "row.batchCode",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "expiryDate",
                      label: "Product Expiry Date",
                      align: "center",
                      width: "170",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "BusinessPurchaseOrder2.form.expiryDate"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("BjDateTimerPicker", {
                              model: {
                                value: row.expiryDate,
                                callback: function ($$v) {
                                  _vm.$set(row, "expiryDate", $$v)
                                },
                                expression: "row.expiryDate",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("goodsPage.length"),
                      prop: "length",
                      align: "center",
                      width: "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_vm._v(" " + _vm._s(row.length) + " cm ")]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("goodsPage.width"),
                      prop: "width",
                      align: "center",
                      width: "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_vm._v(" " + _vm._s(row.width) + " cm ")]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("goodsPage.height"),
                      prop: "height",
                      align: "center",
                      width: "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_vm._v(" " + _vm._s(row.height) + " cm ")]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("goodsPage.volume"),
                      prop: "volume",
                      align: "center",
                      width: "170",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  (row.width * row.height * row.length) /
                                    1000000
                                ) +
                                " m³ "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("goodsPage.weight"),
                      prop: "weight",
                      align: "center",
                      width: "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_vm._v(" " + _vm._s(row.weight) + " kg ")]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: _vm.$t("table.operationText"),
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return [
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.onDelete(row, $index)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("delText")))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              ref: "downPDFTemp",
              staticClass: "bj-col bj-col-24",
              staticStyle: {
                position: "absolute",
                left: "-3000px",
                border: "none",
              },
            },
            [
              _c("BjDivider", [
                _vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder2.detailTitle"))),
              ]),
              _c("div", { staticClass: "bj-row mt20" }, [
                _c("div", { staticClass: "bj-col bj-col-12" }, [
                  _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-form-item-label" }, [
                      _vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder3.id"))),
                    ]),
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(_vm._s(_vm.downloadData.code)),
                    ]),
                  ]),
                  _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-form-item-label" }, [
                      _vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder3.Status"))),
                    ]),
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(_vm._s(_vm.downloadData.status)),
                    ]),
                  ]),
                  _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-form-item-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "BusinessPurchaseOrder3.warehouseReceiptRemarks"
                          )
                        )
                      ),
                    ]),
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(_vm._s(_vm.downloadData.customerRemarks)),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "bj-col bj-col-12" }, [
                  _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-form-item-label" }, [
                      _vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder3.Date"))),
                    ]),
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("timeFilters")(_vm.downloadData.creationDate)
                        )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-form-item-label" }, [
                      _vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder3.Item"))),
                    ]),
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.downloadData.purchaseOrderGoods &&
                            _vm.downloadData.purchaseOrderGoods.length
                        )
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "bj-row mt20" }, [
                _c(
                  "div",
                  { staticClass: "bj-col bj-col-12" },
                  [
                    _c("div", { staticClass: "bj-form-item" }, [
                      _c("div", { staticClass: "bj-form-item-label" }, [
                        _vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder2.Unit"))),
                      ]),
                      _c("div", { staticClass: "bj-form-item-value" }, [
                        _vm._v(_vm._s(_vm.downloadData.shippingMethod)),
                      ]),
                    ]),
                    _vm.downloadData.shippingMethod === "Container"
                      ? [
                          _c("div", { staticClass: "bj-form-item" }, [
                            _c("div", { staticClass: "bj-form-item-label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "BusinessPurchaseOrder2.form.containerId"
                                  )
                                )
                              ),
                            ]),
                            _c("div", { staticClass: "bj-form-item-value" }, [
                              _vm._v(_vm._s(_vm.downloadData.containerId)),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                    _vm.downloadData.shippingMethod !== "Container"
                      ? [
                          _vm.downloadData.shippingMethod === "Pallet"
                            ? _c("div", { staticClass: "bj-form-item" }, [
                                _c(
                                  "div",
                                  { staticClass: "bj-form-item-label" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "BusinessPurchaseOrder3.PalletQty"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "bj-form-item-value" },
                                  [_vm._v(_vm._s(_vm.downloadData.palletQty))]
                                ),
                              ])
                            : _vm._e(),
                          _vm.downloadData.shippingMethod === "Carton"
                            ? _c("div", { staticClass: "bj-form-item" }, [
                                _c(
                                  "div",
                                  { staticClass: "bj-form-item-label" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "BusinessPurchaseOrder3.cartonQty"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "bj-form-item-value" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.downloadData.containerQty)
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "bj-form-item" }, [
                            _c("div", { staticClass: "bj-form-item-label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "BusinessPurchaseOrder2.form.thirdCode"
                                  )
                                )
                              ),
                            ]),
                            _c("div", { staticClass: "bj-form-item-value" }, [
                              _vm._v(_vm._s(_vm.downloadData.thirdCode)),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "bj-col bj-col-12" },
                  [
                    _vm.downloadData.shippingMethod === "Container"
                      ? [
                          _c("div", { staticClass: "bj-form-item" }, [
                            _c("div", { staticClass: "bj-form-item-label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "BusinessPurchaseOrder2.form.containerLength"
                                  )
                                )
                              ),
                            ]),
                            _c("div", { staticClass: "bj-form-item-value" }, [
                              _vm._v(_vm._s(_vm.downloadData.containerLength)),
                            ]),
                          ]),
                          _c("div", { staticClass: "bj-form-item" }, [
                            _c("div", { staticClass: "bj-form-item-label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("BusinessPurchaseOrder2.dropOffMethod")
                                )
                              ),
                            ]),
                            _c("div", { staticClass: "bj-form-item-value" }, [
                              _vm._v(_vm._s(_vm.downloadData.dropOffMethod)),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                    _c("div", { staticClass: "bj-form-item" }, [
                      _c("div", { staticClass: "bj-form-item-label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("BusinessPurchaseOrder2.receiveDate"))
                        ),
                      ]),
                      _c("div", { staticClass: "bj-form-item-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("timeFilters")(_vm.downloadData.receiveDate)
                          )
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "dialogList",
        attrs: {
          multiple: "",
          config: _vm.$BjDialogListConfig.skuDefault("SelectSKUText", {
            columns: _vm.columns,
            search: _vm.search,
          }),
          "check-method": _vm.checkMethod,
        },
        on: { confirm: _vm.onAddDialogConfirm },
      }),
      _c("ExcelImportDialog", {
        ref: "ExcelImport",
        on: { submit: _vm.getTableData },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("goodsPage.dPs1"),
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            visible: _vm.dialogVisible,
            width: "40%",
            "before-close": _vm.handleDialogClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t("goodsPage.dPs2")))]),
          _c("br"),
          _c("br"),
          _c("span", [_vm._v(_vm._s(_vm.$t("goodsPage.dPs3")))]),
          _c("br"),
          _c("br"),
          _c("span", [_vm._v(_vm._s(_vm.$t("goodsPage.dPs4")))]),
          _c("br"),
          _c("br"),
          _c("span", [_vm._v(_vm._s(_vm.$t("goodsPage.dPs5")))]),
          _c("br"),
          _c("br"),
          _c("br"),
          _c("span", [_vm._v("Best Regards")]),
          _c("br"),
          _c("span", [_vm._v("CSG 3PL Team")]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleDialogClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleDialogConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("goodsPage.dPs6")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }